export interface UploadImageOptions {
  convertHeicToJpg?: boolean;
  maxDimension?: number;
}

export interface ImageDimensions {
  width: number;
  height: number;
}

export interface ImageUploadResult {
  path: string;
  dimensions: ImageDimensions;
}
export interface ProcessedImage {
  blob: Blob;
  dimensions: ImageDimensions;
}
export const DEFAULT_UPLOAD_IMAGE_OPTIONS: UploadImageOptions = {
  convertHeicToJpg: true,
  maxDimension: 1024,
};
